import { FormControl, FormHelperText, TextField, Typography, styled } from '@mui/material';
import React from 'react';

const BootstrapInput = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    input: {
      fontSize: 14,
      padding: '10px 12px',
      transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgb(145 158 171)',
    },
    '&.Mui-focused': {
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: '#2684ff',
      },
    },
    '& input:disabled': {
      backgroundColor: '#f0f0f0',
      color: theme.palette.text.primary,
      textFillColor: theme.palette.text.primary,
    },
  },
}));

function InputControl({
  error,
  label = '',
  required = false,
  fullWidth = true,
  helperText,
  onlyNumber = false,
  children,
  ...rest
}) {
  const { dataTestId, slotProps = {}, ...otherRest } = rest;

  const handleChange = e => {
    if (onlyNumber) {
      e.target.value = e.target.value.replace(/\D/g, '');
    }
    otherRest.onChange && otherRest.onChange(e);
  };

  const htmlInputProps = {
    ...(slotProps.htmlInput || {}),
    ...(dataTestId ? { 'data-testid': dataTestId } : {}),
  };

  return (
    <FormControl error={error} variant='standard' required={required} fullWidth={fullWidth}>
      {label && (
        <Typography variant='body1'>
          {label}
          {required && <span className='redstar'>*</span>}
        </Typography>
      )}
      <BootstrapInput
        fullWidth={fullWidth}
        required={required}
        error={error}
        slotProps={{
          ...slotProps,
          htmlInput: htmlInputProps,
        }}
        {...otherRest}
        onChange={handleChange}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {children}
    </FormControl>
  );
}

export default InputControl;
